'use memo';

import type { ComboboxTriggerWidth } from '@/components/Combobox/comboboxTriggerWidth';
import { WorkerTypeCombobox } from '@/components/Combobox/WorkerTypeCombobox/WorkerTypeCombobox';
import type { WorkerType } from '@/constants/workerType';
import { CFormItemBase, type CFormItemProps, buildCFormItem } from '../CFormItem';
type WorkerTypeSelectKind = Extract<WorkerType, 'EMPLOYEE' | 'CONTRACTOR'>;
type Props = CFormItemProps & {
  workerType: WorkerTypeSelectKind;
  value?: string;
  displayValue?: string;
  onChange: (id: string, name: string) => void;
  width?: ComboboxTriggerWidth;
};
export const CFormWorkerTypeSelectItem = buildCFormItem((props: Props) => {
  return <CFormItemBase {...props} readComponent={props.displayValue || props.value} writeComponent={<WorkerTypeCombobox workerType={props.workerType} workerTypeId={props.value} workerTypeName={props.displayValue || ''} setWorkerType={props.onChange} disabled={props.readonly} width={props.width} />} />;
});